import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { BarChart3, ClipboardList, FileQuestion, KeyRound, Gauge } from 'lucide-react';
import PerfDashboard from './PerfDashboard';
import PerfReviewsTab from './PerfReviewsTab';
import PerfTemplateTab from './PerfTemplateTab';
import PerfAccessTab from './PerfAccessTab';

export default function PerformancePage() {
  const { user } = useAuth();
  const [tab, setTab] = useState('dashboard');
  const isCeo = user?.email === 'josh@tnsprograms.org';
  const allowed = isCeo || user?.perf_review_access;

  if (!allowed) {
    return (
      <div className="p-8 max-w-xl" data-testid="perf-denied">
        <h1 className="text-2xl font-bold text-[#2D1B4E]">Performance Reviews</h1>
        <p className="text-sm text-[#8E85A0] mt-2">This portal is limited to accounts granted performance review access.</p>
      </div>
    );
  }

  const tabs = [
    ['dashboard', 'Dashboard', Gauge],
    ['reviews', 'Reviews', ClipboardList],
    ['template', 'Survey Template', FileQuestion],
    ...(isCeo ? [['access', 'Access', KeyRound]] : []),
  ];

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-5 max-w-7xl" data-testid="performance-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#2D1B4E] flex items-center gap-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <BarChart3 className="h-7 w-7 text-[#6B3FA0]" /> Performance Reviews
        </h1>
        <p className="text-sm text-[#8E85A0] mt-1">Staged reviews: self → manager → director, with AI summaries sent after in-person reviews.</p>
      </div>

      <div className="flex gap-1.5 flex-wrap">
        {tabs.map(([k, label, Icon]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`perf-tab-${k}`}
                  className={`flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-bold transition-colors ${
                    tab === k ? 'bg-[#6B3FA0] text-white' : 'bg-white border border-[#DED8EB] text-[#5A4D6E] hover:border-[#6B3FA0]'}`}>
            <Icon className="h-3.5 w-3.5" /> {label}
          </button>
        ))}
      </div>

      {tab === 'dashboard' && <PerfDashboard />}
      {tab === 'reviews' && <PerfReviewsTab />}
      {tab === 'template' && <PerfTemplateTab />}
      {tab === 'access' && isCeo && <PerfAccessTab />}
    </div>
  );
}
